import { z } from "zod";

export const DocumentationPageAnchor = z.object({
  blockId: z.string(),
  level: z.number(),
  text: z.string(),
});

export type DocumentationPageAnchor = z.infer<typeof DocumentationPageAnchor>;
